module.exports = __webpack_public_path__ + "img/d_v1.86cbc28.png";